type OverviewProps = {
  onStartDemo: () => void;
};

export default function Overview({ onStartDemo }: OverviewProps) {
  return (
    <div className="bg-white rounded shadow p-0 flex flex-col h-full min-h-[600px]">
      {/* Tab Bar */}
      <div className="relative flex items-center bg-white">
        <div className="flex items-end w-full" style={{ position: 'relative' }}>
          <div
            className="group relative flex items-center px-3 py-2 cursor-default bg-white"
            style={{ 
              fontSize: '12px',
              width: '160px',
              marginRight: 0
            }}
          >
            <span 
              className="truncate"
              style={{ fontSize: '12px', flex: 1, color: '#212121', fontWeight: 500 }}
            >
              Overview
            </span>
            {/* Orange line under tab */}
            <div
              className="absolute left-0 right-0"
              style={{ 
                bottom: 0, 
                height: 2, 
                background: '#f97316', 
                zIndex: 1
              }}
            />
          </div>
        </div>
        {/* Bottom border */}
        <div
          className="absolute left-0 right-0"
          style={{ 
            bottom: 0, 
            borderBottom: '1px solid #EDEDED',
            zIndex: 0
          }}
        />
      </div>

      {/* Content */}
      <div className="flex-1 overflow-auto px-8 py-6">
        <div className="max-w-3xl">
          {/* Introduction */}
          <div className="mb-8">
            <h1 className="text-2xl font-semibold text-gray-900 mb-3 flex items-center gap-2">
              <span>👋</span> Welcome to Supaserver
            </h1>
            <p className="text-gray-600 leading-relaxed">
              Your backend, ready in seconds. Define endpoints, store data, and go live without managing servers.
            </p>
            <p className="text-gray-600 leading-relaxed mt-3">
              Click the <strong>+</strong> button in the sidebar to create your first collection, or try the demo:
            </p>
            <button
              onClick={onStartDemo}
              className="mt-4 px-5 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 transition-colors font-medium text-sm cursor-pointer"
            >
              Start Demo
            </button>
          </div>

          {/* Getting Started */}
          <div className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-3 flex items-center gap-2">
              <span>🚀</span> Getting started
            </h2>
            
            <div className="space-y-4">
              <div>
                <h3 className="font-medium text-gray-800 mb-1">Collections</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Organize your API endpoints into collections. Each collection can contain multiple requests (GET, POST, PUT, DELETE) that you can execute in real-time.
                </p>
              </div>
              
              <div>
                <h3 className="font-medium text-gray-800 mb-1">Requests</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Create requests to define your API endpoints. Add request bodies, execute them instantly, and get ready-to-use code snippets for integration.
                </p>
              </div>

              <div>
                <h3 className="font-medium text-gray-800 mb-1">Data Storage</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Your data is automatically stored and managed. No database setup required — just send requests and your data persists.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

